import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './app/pages/App'
import { DeckProvider } from './app/context/DeckContext'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DeckProvider>
      <App />
    </DeckProvider>
  </StrictMode>,
)
